export default __webpack_public_path__ + "static/media/waves.298c1cc4.mp3";